import { Entity, FieldType, OptionsField, PersistenceType } from 'gossamer-unified';
import { Institution } from './Institution';
import { TaskDefinition } from 'gossamer-model';

export interface TaskDefnViewRow {
  institution_id: number;
  id: number;
  parent_definition_id: number | null;
  type: string;
  seq: number;
  label: string;
  pending_count: number;
  active_count: number;
  completed_count: number;
  completed_percentage: string;
}

export const TaskDefnView: Entity<TaskDefnViewRow> = {
  id: 'TaskDefnView',
  title: 'Task Definition View',
  service: 'main',
  rowLabel: (row: TaskDefnViewRow) => row.label,
  primaryKeyFields: ['id'],
  source: {
    tableName: 'public.task_defn_view',
  },
  defaultSort: [['seq', 'ASC']],
  security: [
    { role: 'admin', action: 'read', access: 'conditional', condition: 'institution_id = {adminInstitutionId}' },
    { role: 'staff', action: 'read', access: 'all' },
  ],
  listRowLink: (key: string) => `/admin/workflow/display/${key}`,
  fields: {
    institution_id: {
      seq: 5,
      type: FieldType.Reference,
      label: 'Institution',
      refEntity: Institution,
    },
    id: {
      seq: 10,
      type: FieldType.Integer,
      label: 'Id',
    },
    parent_definition_id: {
      seq: 15,
      type: FieldType.Integer,
      label: 'Parent Definition',
    },
    type: {
      seq: 16,
      type: FieldType.Options,
      label: 'Type',
      options: (TaskDefinition.fields.type as OptionsField).options,
    },
    seq: {
      seq: 17,
      type: FieldType.Integer,
      label: 'Sequence',
    },
    label: {
      seq: 20,
      type: FieldType.Text,
      label: 'Label',
      listColumn: true,
    },
    pending_count: {
      seq: 25,
      type: FieldType.Integer,
      label: 'Pending Task Count',
      listColumn: true,
      fieldGroup: 'summary',
    },
    active_count: {
      seq: 30,
      type: FieldType.Integer,
      label: 'Active Task Count',
      listColumn: true,
      fieldGroup: 'summary',
    },
    completed_count: {
      seq: 35,
      type: FieldType.Integer,
      label: 'Completed Task Count',
      listColumn: true,
      fieldGroup: 'summary',
    },
    completed_percentage: {
      seq: 40,
      type: FieldType.Text,
      label: 'Completed Percentage',
      listColumn: true,
      fieldGroup: 'summary',
      listColumnAlign: 'right',
      persistence: PersistenceType.FrontEndOnly,
      evaluateFrontEndIn: (row: TaskDefnViewRow) => {
        const denominator = row.pending_count + row.active_count + row.completed_count;
        return denominator === 0 ? '-' : ((row.completed_count / denominator) * 100).toFixed(0) + '%';
      },
    },
  },
};
